<div class="single-email-thread-container">
  <div class="single-email-thread-sender-sent-time-container flex flex-row justify-between items-center">
    <div class="single-email-thread-participant flex flex-row justify-start items-center">
      <div class="single-email-thread-direction-label">
        From:
      </div>
      <div class="single-email-thread-sender-name">
        {{email.sender.firstName}}{{" "}}{{email.sender.lastName}}
      </div>
      <a (click)="onSenderEmailClick(email.sender.email)" class="single-email-thread-sender-email link-color">
        {{"<"}}{{email.sender.email}}{{">"}}
      </a>
      <i class="fa-solid fa-shield-check verified m-lr-5"></i>
    </div>
    <!--  fix date time diff-->
    <div class="flex flex-row justify-start items-center">
      <div
        class="email-sent-time">{{ now.valueOf() - email.sentTime.valueOf() > 24 * 60 * 60 * 1000 ? (email.sentTime|date: 'shortTime') : (email.sentTime|date: 'shortTime') }}</div>
      <i (click)="onEmailAction(email.isImportant? 'markAsImportant' : 'markAsUnimportant')"
         class="fa-solid fa-star starr m-lr-5"></i>
    </div>
  </div>

  <div class="single-email-thread-participant flex flex-row justify-start items-center">
    <div class="single-email-thread-direction-label">
      To:
    </div>
    <div class="single-email-thread-recipient-names">
      {{recipientsDisplayText}}
    </div>
  </div>
  <div class="single-email-labels">
    <mat-chip-listbox aria-label="Email Labels">
      <mat-chip *ngFor="let label of labels" [ngStyle]="{background:label.color}" selected>{{label.title}}</mat-chip>
    </mat-chip-listbox>
  </div>
  <div class="single-email-action-buttons flex flex-row justify-between items-center">
    <div class="action-icons-container-group flex flex-row">
      <div (click)="onEmailAction('archive')" class="action-item flex flex-row justify-center items-center">
        <i class="fa-regular fa-box-archive"></i>
      </div>
      <mat-divider [vertical]="true" class="m-tb-10"></mat-divider>
      <div (click)="onEmailAction('markAsUnread')" class="action-item flex flex-row justify-center items-center">
        <i class="fa-regular fa-envelope"></i>
      </div>
      <mat-divider [vertical]="true" class="m-tb-10"></mat-divider>
      <div (click)="onEmailAction('delete')" class="action-item flex flex-row justify-center items-center">
        <i class="fa-regular fa-trash-can"></i>
      </div>
      <mat-divider [vertical]="true" class="m-tb-10"></mat-divider>
      <div (click)="onEmailAction('archive')" class="action-item flex flex-row justify-center items-center">
        <i class="fa-regular fa-folder"></i>
      </div>
      <mat-divider [vertical]="true" class="m-tb-10"></mat-divider>
      <div (click)="onEmailAction('manageLabel')" class="action-item flex flex-row justify-center items-center">
        <i class="fa-regular fa-tag"></i>
      </div>
    </div>

    <div class="action-icons-container-group flex flex-row">
      <div (click)="onEmailAction('reply')" class="action-item flex flex-row justify-center items-center">
        <i class="fa-regular fa-reply"></i>
      </div>
      <mat-divider [vertical]="true" class="m-tb-10"></mat-divider>
      <div (click)="onEmailAction('replyAll')" class="action-item flex flex-row justify-center items-center">
        <i class="fa-regular fa-reply-all"></i>
      </div>
      <mat-divider [vertical]="true" class="m-tb-10"></mat-divider>
      <div (click)="onEmailAction('forward')" class="action-item flex flex-row justify-center items-center">
        <i class="fa-regular fa-share"></i>
      </div>
    </div>
  </div>
  <!--<particle-reply-message></particle-reply-message>-->
  <app-email-content-editor [recipients]="newEmailRecipients" *ngIf="showEditor"
                            (sendMail)="onEmailAction('send', $event)"
                            (discardMail)="onEmailAction('discard', {})"></app-email-content-editor>
  <div class="email-content" [innerHTML]="email.content | sanitizeHtml"></div>
</div>
